import type { CSSProperties } from 'react';
import styled, { keyframes } from 'styled-components';

import type { RgbString } from '@sorare/core/src/lib/colors';
import type { RGBColor } from '@sorare/core/src/style/types';

const growAnimation = keyframes`
    0% {
      opacity: 1;
      transform: scale(0.8);
    }
    80% {
        opacity: 0.2;
        transform: scale(1.25)
    }
    100% {
      opacity: 0;
      transform: scale(1.25);
    }
`;
const Root = styled.div`
  width: 100%;
  position: relative;
  opacity: 0;
  transform: scale(0.8);
  aspect-ratio: var(--card-aspect-ratio);
  border: 3px solid rgb(var(--glow-rgb, 255, 255, 255));
  border-radius: var(--unit);
  box-shadow:
    0 0 5px rgba(var(--glow-rgb, 255, 255, 255), 0.8),
    0 0 10px rgba(var(--glow-rgb, 255, 255, 255), 0.5),
    0 0 15px rgba(var(--glow-rgb, 255, 255, 255), 0.3),
    inset 0 0 5px rgba(var(--glow-rgb, 255, 255, 255), 0.8),
    inset 0 0 10px rgba(var(--glow-rgb, 255, 255, 255), 0.5),
    inset 0 0 15px rgba(var(--glow-rgb, 255, 255, 255), 0.3);
  animation: ${growAnimation} 1s var(--ease-in-out-quart) var(--delay, 0ms)
    forwards;
`;
const AbsoluteRoot = styled(Root)`
  position: absolute;
  inset: 0;
`;

type Props = { show: boolean; color?: RgbString | RGBColor | null };
export const NewCardAnimation = ({ show, color }: Props) => {
  if (!show) return null;
  const colorStyle = color
    ? ({ '--glow-rgb': color } as CSSProperties)
    : undefined;
  return (
    <>
      <Root style={colorStyle} />
      <AbsoluteRoot
        style={{ ...colorStyle, '--delay': '200ms' } as CSSProperties}
      />
    </>
  );
};
